








































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import { parseError, UNKNOWN_ERROR } from '@/utils/errors.ts';

const StartSessionMutation = gql`
  mutation StartSession($centerId: ID!, $lanes: [Int]!, $isLeague: Boolean) {
    startBowlingSession(centerId: $centerId, lanes: $lanes, isLeague: $isLeague) {
      id
    }
  }
`;

@Component({
  components: {
  },
})
export default class StartSession extends Vue {
  @Prop({ required: true, type: Array })
  public availableLanes!: number[];

  @Prop({ required: true, type: String })
  public centerId!: string;

  public crossLaneSelected: boolean = this.isLanePair;
  public lanesSelected: number[] = this.availableLanes;
  public isLeague: boolean = false;

  public loading: boolean = false;
  public error: string | null = null;

  get isAdmin(): boolean {
    return store.getters['auth/canManageCenter'](this.centerId);
  }

  public startSession() {
    if (!this.lanesSelected) {
      this.error = 'Please select some lanes.';
      return;
    }

    this.loading = true;
    this.$apollo.mutate({
      mutation: StartSessionMutation,
      variables: {
        centerId: this.centerId,
        lanes: this.lanesSelected,
        // Only cross-lane admin sessions expose the league toggle; otherwise
        // this stays false (matching the server default).
        isLeague: this.crossLaneSelected && this.isAdmin ? this.isLeague : false,
      },
    }).then((r) => {
      this.loading = false;
      this.$emit('sessionStarted');
    }).catch((e) => {
      this.loading = false;
      this.error = parseError(e) || UNKNOWN_ERROR;
    });
  }

  get isLanePair() {
    return this.availableLanes.length === 2;
  }

  get sortedLanes() {
    return this.availableLanes.sort((a, b) => a - b);
  }
}
